export const DIALOG_PROMPT_NS = "DialogPrompt";

export const i18n = {
  en: {
    restart: {
      heading: "Are you sure you want to restart the ADP Onboard service?",
      text: "This will end the current session, including local users connected to the system",
      button: "Restart service",
    },
    reset: {
      heading: "Are you sure you want to reset the ADP Onboard installation?",
      text: "This will end the current session and reset all ADP Onboard data on this system",
      button: "Reset",
    },
  },
};
